import React from "react";
 
const ContactPopup = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50">
      <div className="relative bg- p-8 rounded-lg w-full max-w-3xl">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-1 text-white text-2xl "
        >
          ✖
        </button>    
        {/* Image that links to contact page */}
        <a href="/contact-glowtech-solutions" className="mx-auto">
          <img
            src="banner.jpeg"
            alt="Banner Image"
            className=""
          />
        </a>
      </div>
    </div>
  );
};
 
export default ContactPopup;